import { render, staticRenderFns } from "./StatisticsProducts.vue?vue&type=template&id=7e991532&"
import script from "./StatisticsProducts.vue?vue&type=script&lang=js&"
export * from "./StatisticsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports